/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { user } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const TOTP_SECRET = 'user.totpSecret';

queryClient.setQueryDefaults(TOTP_SECRET, {
  queryFn: () => user.totpSecret(),
  onError: (error) => {
    handleError(error);
  },
});
